import React, { Component } from "react"
import { Route, Redirect } from "react-router-dom"
import { Switch } from "react-router"
import ResearchCanvas from "../../components/ResearchCanvas"
import { PrivateRouteWithData } from "../../shared/routeHandlers"
import Message from "../../components/Message"
import Button from "../../components/Button"
import TopNav from "../../components/TopNav"
import { Helmet } from "react-helmet"
import qs from "qs"
import AppContext from "../../shared/AppContext"

import "./research.scss"
import Loading from "../../components/Loading"

const getDatasetFromRoute = (route) => {
  switch (route.toLowerCase()) {
    case "research":
      return "TSIS"
    case "ets":
      return "ETS"
    case "admin-bi":
      return "ADMIN"
  }
}

class Research extends Component {
  constructor(props) {
    super(props)
  }

  render = () => {
    let { viewer } = this.props.data
    let { fullscreen } = qs.parse(this.props.location.search, {
      ignoreQueryPrefix: true,
    })

    if (!viewer) return null

    let dataset = getDatasetFromRoute(this.props.match.params.dataset)
    let links = [],
      routes = [],
      activeBook
    if (dataset === "ADMIN" && !viewer.isUserAuthenticated) {
      return (
        <Redirect
          to={{
            pathname: "/login",
            state: {
              from: this.props.location,
            },
          }}
        />
      )
    }

    for (const book of this.props.books) {
      if (book.dataset.toUpperCase() !== dataset) continue

      if (
        book.path.toLowerCase() === this.props.match.params.book.toLowerCase()
      ) {
        activeBook = book
      }

      if (book.chapters.length > 0) {
        links.push({
          title: book.displayName,
          to: {
            pathname: `/${this.props.match.params.dataset}/${book.path}/${book.chapters[0].path}`,
            search: qs.stringify({ fullscreen }, { addQueryPrefix: true }),
          },
        })

        for (const chapter of book.chapters) {
          routes.push({
            path: `/${this.props.match.params.dataset}/${book.path}/${chapter.path}`,
            exact: true,
            render: (routeProps) => (
              <ResearchCanvas
                {...this.props}
                book={book}
                chapter={chapter}
                {...routeProps}
              />
            ),
          })
        }
      }
    }

    if (
      dataset === "ADMIN" &&
      viewer.isUserAuthenticated &&
      links.length === 0
    ) {
      if (this.props.loading) {
        return <Loading />
      }

      return (
        <Message
          type="error"
          title="Not Authorized"
          message="You are not authorized to view this page!"
        >
          <Button
            action={() => this.props.history.push("/")}
            classes={["btn-primary", "btn-lg", "small-caps"]}
            text="ETR Home"
          />
        </Message>
      )
    }

    return (
      <div className="research-main-container">
        <Helmet>
          <title>Research | ETR</title>
        </Helmet>
        {fullscreen === "true" && (
          <TopNav
            navItems={links}
            isActive={(item) =>
              item.title.toLowerCase() === activeBook.displayName.toLowerCase()
            }
          />
        )}
        <Switch>
          {routes.map((route, i) => (
            <PrivateRouteWithData key={i} {...route} />
          ))}
          <Route render={() => <Redirect to="/Not-Found" />} />
        </Switch>
      </div>
    )
  }
}

const ResearchWithContext = (props) => {
  return (
    <AppContext.Consumer>
      {({ openInquireModal, serviceType }) => {
        return (
          <Research
            {...props}
            key={props.match.url}
            openInquireModal={openInquireModal}
            serviceType={serviceType}
          />
        )
      }}
    </AppContext.Consumer>
  )
}

export default ResearchWithContext
